import { PatientSimple } from '@dreryk/egabinet-patient-frontend-api';
import { Patient as WaitlistPatient } from '@dreryk/egabinet-waitlist-frontend-api';

import { PatientFieldItem } from './PatientFieldItem';

export const isPatientSimple = (patient: PatientSimple | WaitlistPatient): patient is PatientSimple => {
   return typeof patient.id === 'number';
};

export const patientLabelExtractor = (patient: PatientSimple | WaitlistPatient): string => {
   const name = `${patient.lastName ?? ''} ${patient.firstName ?? ''}`.trim();
   if (name) {
      return name;
   }

   if (!isPatientSimple(patient)) {
      return '';
   }

   const externalIdentifier = patient.referenceIdentifier?.findExternalIdentifier();
   const patientPesel = externalIdentifier?.accept<string | null>({
      visitPesel: (pesel) => pesel.asString(),
      visitGuardianPesel: () => null,
      visitPassport: () => null,
      visitNationalIdentificationNumber: () => null,
   });

   if (patientPesel) {
      return patientPesel;
   }

   if (patient.phoneNumber) {
      return patient.phoneNumber.asString();
   }

   return '';
};

export const patientItemRenderer = (patient: PatientSimple | WaitlistPatient): JSX.Element => (
   <PatientFieldItem patient={patient} />
);
